import './index.css';
import PaginaInicial from './components/PaginaInicial';

function App() {
  return <PaginaInicial />;
}

export default App;